<template>
  <div class="phone-code-query">
    <el-card class="phone-code-query__card">
      <div class="phone-code-query__title">手机验证码查询</div>
      
      <div class="phone-code-query__form">
        <el-form :inline="true" :model="queryForm" class="query-form">
          <el-form-item>
            <div class="phone-input-wrapper">
              <el-select 
                v-model="queryForm.countryCode" 
                class="country-code-select"
                placeholder="+86"
                filterable
                style="width: 200px;"
              >
                <el-option
                  v-for="item in countryCodeOptions"
                  :key="item.iso2 || item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">{{ item.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                </el-option>
              </el-select>
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入手机号"
                class="phone-input"
                style="flex: 1;"
                @keyup.enter.native="handleQuery"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="phone-code-query__result" v-if="queryResult">
        <div class="result-box">
          <div class="result-item">
            <span class="result-label">验证码:</span>
            <span class="result-value">{{ queryResult.code || '-' }}</span>
          </div>
          <div class="result-item">
            <span class="result-label">发送时间:</span>
            <span class="result-value">{{ formatTime(queryResult.time) }}</span>
          </div>
          <div class="result-item" v-if="queryResult.result">
            <span class="result-label">发送结果:</span>
            <span class="result-value">{{ queryResult.result }}</span>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { allCountries } from 'country-telephone-data'

export default {
  name: 'PhoneCode',
  data() {
    return {
      queryForm: {
        countryCode: '+86',
        phone: ''
      },
      queryResult: null,
      countryCodeOptions: []
    }
  },
  mounted() {
    this.initCountryCodeOptions()
  },
  methods: {
    // 初始化国家代码选项
    initCountryCodeOptions() {
      // 使用country-telephone-data库获取所有国家数据
      // 按国家名称排序，方便查找
      const sortedCountries = [...allCountries].sort((a, b) => {
        return a.name.localeCompare(b.name, 'zh-CN')
      })
      
      // 转换为需要的格式
      this.countryCodeOptions = sortedCountries.map(country => {
        // 获取国家名称和电话代码
        const name = country.name || ''
        const dialCode = country.dialCode || ''
        
        // 格式化显示标签（国家名称 + 电话代码）
        return {
          label: `${name} ${dialCode}`,
          value: dialCode,
          name: name,
          iso2: country.iso2 || ''
        }
      })
      
      // 确保默认选中中国
      const chinaIndex = this.countryCodeOptions.findIndex(item => item.value === '+86' || item.iso2 === 'CN')
      if (chinaIndex > 0) {
        // 将中国移到第一位
        const china = this.countryCodeOptions.splice(chinaIndex, 1)[0]
        this.countryCodeOptions.unshift(china)
      }
      
      // 确保默认值是中国（如果找到了中国选项）
      if (chinaIndex >= 0) {
        this.queryForm.countryCode = '+86'
      }
    },
    async handleQuery() {
      // 验证手机号
      if (!this.queryForm.phone || this.queryForm.phone.trim() === '') {
        this.$message({
          type: 'warning',
          message: '手机号不能为空'
        })
        return
      }

      // 构建查询参数
      const params = {
        phone: this.queryForm.countryCode + this.queryForm.phone.trim(),
        username: this.$store.getters.username,
        token: this.$store.getters.token
      }

      // 如果URL中有发送结果参数，添加到查询参数中
      const urlResult = this.$route.query.result
      if (urlResult && urlResult.trim() !== '') {
        params.result = urlResult.trim()
      }

      try {
        const { data: res } = await this.$axios({
          method: 'get',
          url: this.$store.getters.path.sms_query,
          withCredentials: true,
          params: params
        })

        if (res.code === 0) {
          this.queryResult = res.data
          this.$message({
            type: 'success',
            message: '查询成功'
          })
        } else {
          this.queryResult = null
          this.$message({
            type: 'error',
            message: res.msg || '查询失败'
          })
        }
      } catch (error) {
        this.queryResult = null
        this.$message({
          type: 'error',
          message: '查询失败: ' + (error.message || '未知错误')
        })
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '-'
      // 如果是秒时间戳，需要乘以1000转换为毫秒时间戳
      const milliseconds = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
      const date = new Date(milliseconds)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}.${month}.${day} ${hours}:${minutes} (UTC+8)`
    }
  }
}
</script>

<style scoped lang="scss">
.phone-code-query {
  padding: 20px;

  &__card {
    min-height: 400px;
  }

  &__title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  &__form {
    margin-bottom: 30px;

    .query-form {
      .phone-input-wrapper {
        display: flex;
        gap: 10px;
        align-items: center;

        .country-code-select {
          flex-shrink: 0;
        }

        .phone-input {
          flex: 1;
        }
      }
    }
  }

  &__result {
    .result-box {
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      padding: 20px;
      background-color: #fafafa;

      .result-item {
        margin-bottom: 15px;
        font-size: 16px;
        line-height: 1.8;

        &:last-child {
          margin-bottom: 0;
        }

        .result-label {
          color: #606266;
          font-weight: 500;
          margin-right: 10px;
        }

        .result-value {
          color: #303133;
        }
      }
    }
  }
}
</style>
